import React from 'react';
import { ProviderContext } from './types';

// @ts-ignore
export default React.createContext<ProviderContext>();